import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-59fb97bf"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "description" };
const _hoisted_2 = ["contenttype"];
const _hoisted_3 = { class: "upload-file-name" };
const _hoisted_4 = {
    key: 0,
    class: "center"
};
const _hoisted_5 = { class: "upload-warning" };
const _hoisted_6 = { class: "max-size" };
const _hoisted_7 = {
    key: 4,
    class: "wrong-file"
};
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "wrong-file-icon" }, null, -1));
const _hoisted_9 = { class: "flex justify-end gap-md" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_or_input = _resolveComponent("or-input");
    const _component_or_icon = _resolveComponent("or-icon");
    const _component_or_code = _resolveComponent("or-code");
    const _component_or_error = _resolveComponent("or-error");
    const _component_i18n_t = _resolveComponent("i18n-t");
    const _component_contact_books_migration_form = _resolveComponent("contact-books-migration-form");
    const _component_contacts_import_merge_switch = _resolveComponent("contacts-import-merge-switch");
    const _component_or_button = _resolveComponent("or-button");
    const _component_OrModalV3 = _resolveComponent("OrModalV3");
    return (_openBlock(), _createBlock(_component_OrModalV3, {
        ref: "modalComponent",
        "data-test": "import-contacts-modal",
        size: "m"
    }, {
        header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('contacts.importModal.title')), 1)
        ]),
        footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
                (!_ctx.isPage2Open)
                    ? (_openBlock(), _createBlock(_component_or_button, {
                        key: 0,
                        color: "primary",
                        type: "outline",
                        content: _ctx.uploadType === 'file' ? _ctx.$t('contacts.importModal.pasteJsonOrCsv') : _ctx.$t('contacts.importModal.selectFile'),
                        "is-disabled": _ctx.isFirstPageLoading,
                        onClick: _ctx.changeUploadType
                    }, null, 8, ["content", "is-disabled", "onClick"]))
                    : (_openBlock(), _createBlock(_component_or_button, {
                        key: 1,
                        color: "primary",
                        type: "outline",
                        content: _ctx.$t('contacts.importModal.back'),
                        onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.togglePage2Open(false)))
                    }, null, 8, ["content"])),
                _createVNode(_component_or_button, {
                    color: "primary",
                    content: _ctx.$t('contacts.importModal.next'),
                    "is-loading": _ctx.isLoading || _ctx.isFirstPageLoading,
                    "is-disabled": _ctx.isPage2Open ? _ctx.isImportDisabled : _ctx.goToPage2Disabled,
                    onClick: _cache[12] || (_cache[12] = ($event) => (!_ctx.isPage2Open ? _ctx.parseData() : _ctx.importData()))
                }, null, 8, ["content", "is-loading", "is-disabled"])
            ])
        ]),
        default: _withCtx(() => [
            (!_ctx.isPage2Open)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('contacts.importModal.youCanUse')), 1),
                    _createVNode(_component_or_input, {
                        modelValue: _ctx.pastedUrl,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.pastedUrl) = $event)),
                        label: _ctx.$t('contacts.importModal.urlToFile'),
                        onInput: _cache[1] || (_cache[1] = ($event) => (_ctx.resetInputs('pastedUrl')))
                    }, null, 8, ["modelValue", "label"]),
                    (_ctx.uploadType === 'file')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass(["upload-container", { 'upload-container-dragging': _ctx.dragging }])
                        }, [
                            _createElementVNode("div", {
                                class: "upload-wrapper",
                                contenttype: _ctx.fileExtension
                            }, [
                                _createVNode(_component_or_icon, {
                                    class: "upload-icon",
                                    icon: _ctx.fileName ? 'cloud' : 'cloud_upload'
                                }, null, 8, ["icon"]),
                                _createElementVNode("input", {
                                    ref: "uploadInputRef",
                                    type: "file",
                                    class: "upload-input",
                                    style: _normalizeStyle({ 'height': _ctx.fileName ? '207px' : '236px' }),
                                    onChange: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.setFileName && _ctx.setFileName(...args))),
                                    onDragenter: _cache[3] || (_cache[3] = ($event) => (_ctx.dragging = true)),
                                    onDragleave: _cache[4] || (_cache[4] = ($event) => (_ctx.dragging = false)),
                                    onDrop: _cache[5] || (_cache[5] = ($event) => (_ctx.dragging = false))
                                }, null, 36)
                            ], 8, _hoisted_2),
                            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.fileName || _ctx.$t('contacts.importModal.dropFileHere')), 1),
                            (!_ctx.fileName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('contacts.importModal.or')) + " ", 1),
                                    _createElementVNode("span", {
                                        class: "upload-button",
                                        onClick: _cache[6] || (_cache[6] = () => { var _a; return (_a = _ctx.uploadInputRef) === null || _a === void 0 ? void 0 : _a.click(); })
                                    }, _toDisplayString(_ctx.$t('contacts.importModal.uploadFromYourComputer')), 1)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_5, [
                                _createTextVNode(_toDisplayString(_ctx.$t('contacts.importModal.supportingFormats')) + " ", 1),
                                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('contacts.importModal.maximumFileSizeMb')), 1)
                            ])
                        ], 2))
                        : (_openBlock(), _createBlock(_component_or_code, {
                            key: 1,
                            modelValue: _ctx.paste,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.paste) = $event)),
                            class: "code",
                            label: _ctx.$t('contacts.importModal.pasteJsonOrCsv'),
                            onInput: _cache[8] || (_cache[8] = ($event) => (_ctx.resetInputs('paste')))
                        }, null, 8, ["modelValue", "label"])),
                    (_ctx.parsingError)
                        ? (_openBlock(), _createBlock(_component_or_error, { key: 2 }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.parsingError), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.maxFileSizeExceeded)
                        ? (_openBlock(), _createBlock(_component_or_error, { key: 3 }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('contacts.importModal.maxFileSize')), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true),
                    (_ctx.wrongFileFormat)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("div", null, [
                                _createVNode(_component_i18n_t, {
                                    keypath: "contacts.importModal.cantUpload",
                                    scope: "global",
                                    tag: "span"
                                }, {
                                    csv: _withCtx(() => [
                                        _createElementVNode("b", null, _toDisplayString(_ctx.$t('contacts.importModal.csvExtension')), 1)
                                    ]),
                                    json: _withCtx(() => [
                                        _createElementVNode("b", null, _toDisplayString(_ctx.$t('contacts.importModal.jsonExtension')), 1)
                                    ]),
                                    _: 1
                                })
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_contact_books_migration_form, {
                        ref: "migrationFormRef",
                        modelValue: _ctx.mappedColumnsArr,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.mappedColumnsArr) = $event)),
                        "is-loading": _ctx.isLoading,
                        "fields-v2": _ctx.fields,
                        title: _ctx.$t('contacts.importModal.fieldsToImport'),
                        "validation-scope": "ContactsImport"
                    }, null, 8, ["modelValue", "is-loading", "fields-v2", "title"]),
                    _createVNode(_component_contacts_import_merge_switch, {
                        ref: "mergeSwitchRef",
                        modelValue: _ctx.columnToMergeBy,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.columnToMergeBy) = $event)),
                        class: "pt-md",
                        columns: _ctx.inputColumns,
                        "is-loading": _ctx.isLoading
                    }, null, 8, ["modelValue", "columns", "is-loading"])
                ], 64))
        ]),
        _: 1
    }, 512));
}
